import React, {useEffect} from "react";
import Box from "../../lib/appfuse-react/component/Box";
import {withDesktop} from "../../layout/Desktop";
import {useDispatch, useSelector} from "../../store";
import {selectRedirect, selectUserInfo, setUserInfo} from "../../reducer/iam/authReducer";
import authService from "../../service/iam/authService";
import SatisfactionSurveyApplet from "../SatisfactionSurveyApplet";
import CourseAnnouncement from "../CourseAnnouncement";
import {Redirect} from "react-router-dom";

function Main(props) {
    const userInfo = useSelector(selectUserInfo);
    const needRedirect = useSelector(selectRedirect);
    const {defaultApplet} = userInfo;

    if ((defaultApplet === 'satisfactionSurvey' || defaultApplet === 'courseAnnouncement') && needRedirect) {
        const to = defaultApplet === 'satisfactionSurvey' ? '/satisfactionSurvey' : defaultApplet === 'courseAnnouncement' ? '/courseAnnouncement' : '/';
        return <Redirect to={to} />;
    }

    return (
        <Box className="app-main" fullWidth fullHeight backgroundOpacity={0.5} backgroundColor="black">
        </Box>
    );
}

export default withDesktop(Main);